export default {
  version: 'master',
  compilation: '261066'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1475
// module chunks = 22